export const FILE_DOWNLOAD = 'FILE_DOWNLOAD';
export const FILE_UPLOAD = 'FILE_UPLOAD';
